import {
  pageRequest,
  rulePayload,
  errorText,
  responseData,
  newShelfText,
  sortRuleRows
} from '../model'

export default {
  props: {
    filterData: {
      type: Object,
      required: true
    },
    dict: {
      type: Object,
      required: true
    },
    dictLoading: {
      type: Boolean,
      default: false
    },
    dictReady: {
      type: Boolean,
      default: false
    },
    maxTableHeight: {
      type: Number,
      default: 400
    }
  },
  data () {
    return {
      applied: {},
      page: 1,
      size: 30,
      total: 0,
      rows: [],
      loading: false,
      detailLoading: false,
      detailId: 0,
      requestId: 0,
      visible: false,
      form: {},
      saving: false,
      error: '',
      editError: '',
    }
  },
  computed: {
    ruleSummary () {
      return '规则来源于最新规则矩阵，共' + this.total +
        '条；计算公式由系统固定维护，页面仅支持调整判断节点，判断数值和发货周期结果；规则按优先级升序展示'
    },
    columns () {
      return [
        {
          prop: 'className',
          label: '上架分类'
        },
        {
          prop: 'productionLogisticsTypeName',
          label: '生产物流分类',
          width: 170
        },
        {
          prop: 'priorityCode',
          label: '优先级',
          width: 80
        },
        {
          prop: 'supplyChannelName',
          label: '供应渠道',
          width: 170
        },
        {
          prop: 'newShelfJudgement',
          label: '新上架判断',
          width: 100
        },
        {
          prop: 'ruleDesc',
          label: '判断逻辑',
          width: 480
        },
        {
          prop: 'resultDisplay',
          label: this.resultColumnLabel,
          width: 200
        },
        {
          prop: 'ruleVersion',
          label: '规则版本'
        },
        {
          prop: 'operatorName',
          label: '更新人'
        },
        {
          prop: 'updatedTime',
          label: '更新时间',
          width: 170
        }
      ]
    }
  },
  created () {
    this.search()
  },
  beforeDestroy () {
    this.requestId++
    this.detailId++
  },
  methods: {
    search () {
      this.applied = { ...this.filterData }
      // 分页接口使用生产物流分类名称查询，编辑时仍使用编码。
      const production = (this.dict.productionOptions || []).find(
        item => item.value === this.filterData.productionLogisticsType
      )
      if (production) {
        this.applied.productionLogisticsType = production.label
      }

      this.page = 1
      return this.load()
    },
    async load () {
      const id = ++this.requestId
      this.loading = true
      this.$emit('loading-change', true)
      this.error = ''

      try {
        const response = await this.$q.shippingPeriod.rules({
          data: pageRequest(this.page, this.size, {
            ...this.applied,
            configType: this.configType
          })
        })
        const data = responseData(response)
        if (id !== this.requestId) return

        this.rows = sortRuleRows(data.records || []).map(row => ({
          ...row,
          newShelfJudgement: newShelfText(row)
        }))
        this.total = Number(data.total) || 0
      } catch (error) {
        if (id === this.requestId) {
          this.rows = []
          this.total = 0
          this.error = errorText(error)
        }
      } finally {
        if (id === this.requestId) {
          this.loading = false
          this.$emit('loading-change', false)
        }
      }
    },
    async edit (row) {
      if (this.detailLoading) return

      const id = ++this.detailId
      this.detailLoading = true
      this.editError = ''

      try {
        const response = await this.$q.shippingPeriod.ruleDetail({
          params: {
            ruleId: row.ruleId,
            configType: this.configType
          }
        })
        const data = responseData(response)
        if (id !== this.detailId) return

        this.form = {
          ...data,
          configType: this.configType,
          supplyChannels: (data.supplyChannel || '').split('/').filter(Boolean),
          nodes: (data.nodes || []).map(node => ({
            ...node,
            logicConnector: node.logicConnector || 'AND'
          }))
        }
        this.visible = true
      } catch (error) {
        if (id === this.detailId) {
          this.$message.error(errorText(error))
        }
      } finally {
        if (id === this.detailId) {
          this.detailLoading = false
        }
      }
    },
    async save () {
      if (this.saving) return

      const form = this.form
      const allowed = (key, value) => {
        return (this.dict[key] || []).some(item => item.value === value)
      }
      const invalidNode = (form.nodes || []).some(node => {
        return !allowed('fieldOptions', node.fieldCode) ||
          !allowed('operatorOptions', node.judgmentSymbol) ||
          typeof node.judgmentValue !== 'number' ||
          !Number.isFinite(node.judgmentValue) ||
          !allowed('unitOptions', node.unit)
      })
      if (invalidNode) {
        this.editError = '请完整填写有效的判断字段、符号、数值和单位'
        return
      }
      if (!form.supplyChannels.length) {
        this.editError = '规则缺少供应渠道，请确认规则数据'
        return
      }

      const invalidResult = form.resultType === 'FIXED'
        ? !Number.isSafeInteger(form.resultValue) || form.resultValue <= 0
        : form.resultType !== 'SOURCE' ||
          !allowed('sourceFieldOptions', form.resultSourceField)
      if (invalidResult) {
        this.editError = '请选择有效的结果类型，固定周期必须为正整数'
        return
      }

      this.saving = true
      this.editError = ''
      try {
        const response = await this.$q.shippingPeriod.updateRule({
          data: rulePayload(form)
        })
        responseData(response)
        this.visible = false
        this.$message.success('保存成功，下一个数据版本生效')
        await this.load()
      } catch (error) {
        this.editError = errorText(error)
      } finally {
        this.saving = false
      }
    }
  }
}
